document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector(".delivery-wrapper");
  if (!wrapper) return;

  const apiBase = wrapper.dataset.api;
  const input = wrapper.querySelector(".delivery-pincode-input");
  const changeBtn = wrapper.querySelector(".delivery-change-btn");
  const message = wrapper.querySelector(".delivery-message");
  const location = wrapper.querySelector(".delivery-location");

  // Load saved pincode
  const savedPin = localStorage.getItem("user_pincode");
  if (savedPin && /^[0-9]{6}$/.test(savedPin)) {
    input.value = savedPin;
    fetchDelivery(savedPin);
  }

  // Clear message if user edits input
  input.addEventListener("input", function () {
    if (input.value.trim() === "") {
      message.innerHTML = "";
      location.innerHTML = "";
      return;
    }

    // If user edits value different from saved, clear old result
    if (input.value !== localStorage.getItem("user_pincode")) {
      message.innerHTML = "";
      location.innerHTML = "";
    }
  });

  changeBtn.addEventListener("click", function () {
    const pin = input.value.trim();

    if (!/^[0-9]{6}$/.test(pin)) {
      message.innerHTML = "Please enter a valid 6-digit pincode.";
      location.innerHTML = "";
      return;
    }

    localStorage.setItem("user_pincode", pin);
    fetchDelivery(pin);
  });

  async function fetchDelivery(pin) {
    message.innerHTML = "Checking...";
    location.innerHTML = "";

    try {
      const response = await fetch(`${apiBase}/check/${pin}`);
      const data = await response.json();

      if (!data.serviceable) {
        message.innerHTML =
          "We currently do not deliver to this pincode.";
        return;
      }

      const today = new Date();
      const maxDate = new Date();
      maxDate.setDate(today.getDate() + data.delivery_max);

      const options = {
        day: "numeric",
        month: "short",
        year: "numeric"
      };

      message.innerHTML =
        "Get it by <strong>" +
        maxDate.toLocaleDateString("en-IN", options) +
        "</strong>";

      const formattedDistrict = formatLocation(data.district);

      location.innerHTML =
        "Delivery to " +
        formattedDistrict +
        " – " +
        pin;

    } catch (error) {
      message.innerHTML =
        "Unable to check delivery right now.";
      location.innerHTML = "";
    }
  }

  function formatLocation(text) {
    if (!text) return "";

    return text
      .toLowerCase()
      .split(" ")
      .map(word =>
        word.charAt(0).toUpperCase() + word.slice(1)
      )
      .join(" ");
  }
});